import React from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from 'react-router-dom'
function PopUp1Pc({ doNotShowToday, close,popup }) {
  
  const navigate = useNavigate()

  return (
    <Bg>
      <Container>
        <Img src={process.env.REACT_APP_BASE_RESOURCES_API +  popup.popupFileDto.filePath} 
          onClick={() => {
            debugger
            if (popup.popupUrl === null) return false;
            if(popup.popupUrl.indexOf('http')>-1){
              window.location.href=popup.popupUrl;
              return;
            }
            navigate(popup.popupUrl)
          }}
        />
        <Row>
          <Btn1 onClick={doNotShowToday}>오늘 하루 보지 않기</Btn1>
          <Line />
          <Btn2 onClick={close}>닫기</Btn2>
        </Row>
      </Container>
    </Bg>
  );
}

export default PopUp1Pc;
const Bg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
const Container = styled.div`
  width: 452px;
  display: flex;
  flex-direction: column;
  z-index: 1001;
`;
const Img = styled.img`
  object-fit: contain;
`;
const Row = styled.div`
  width: 452px;
  height: 76px;
  background: #fff;
  display: flex;
`;
const Btn1 = styled.div`
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans KR;
  font-weight: 400;
  color: #4f4f4f;
  font-size: 17.1px;
`;
const Line = styled.div`
  width: 1px;
  height: 76px;
  background: #e3e3e3;
`;
const Btn2 = styled(Btn1)`
  font-weight: 700;
  color: #4f4f4f;
`;
